import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import CreatorProfileNav from "./index";

import { apolloClient } from "js/apollo/apollo-client";

const DjangoTemplateCreatorProfileNav = ({ args: propsFromDjangoTemplate }) => {
    return (
        <ApolloProvider client={apolloClient}>
            <CreatorProfileNav
                username={propsFromDjangoTemplate.username}
                defaultTabIndex={0}
            />
        </ApolloProvider>
    );
};

export default DjangoTemplateCreatorProfileNav;
